import { h, } from '@stencil/core';
import { ACTION_TYPES, scrollToComponent, setLinearProductData, store, getPlainPropValue, ETabType } from '@pes-ui/utils';
import { observeIntersectionWithHeader, setStickyBarTab, setTabActive, } from '../../../globals/stickyBar.utils';
import { isMobile } from '../../../globals/utils';
export class EnvironmentalData {
  windowSizeDidChange() {
    this.isMobileView = isMobile();
  }
  handleTabClicked(event) {
    if (this.el && event.detail.type === ETabType.ENVIRONMENTALDATA) {
      scrollToComponent(this.el);
    }
  }
  handleScrollToEnvironmentalData() {
    if (this.el) {
      scrollToComponent(this.el);
    }
  }
  constructor() {
    this.data = undefined;
    this.showMoreLabel = undefined;
    this.showLessLabel = undefined;
    this._data = undefined;
    this._showMoreLabel = '';
    this._showLessLabel = '';
    this.links = [];
    this.filteredGroups = undefined;
    this.isMobileView = isMobile();
    this.el.dir = document.documentElement.dir || 'auto';
  }
  initializeLinks() {
    var _a, _b;
    this.links = (_b = (_a = this._data) === null || _a === void 0 ? void 0 : _a.links) === null || _b === void 0 ? void 0 : _b.filter((link) => (link === null || link === void 0 ? void 0 : link.title) && (link === null || link === void 0 ? void 0 : link.url));
  }
  initializeStickyBarTab() {
    var _a;
    setStickyBarTab(ETabType.ENVIRONMENTALDATA, [(_a = this._data) === null || _a === void 0 ? void 0 : _a.name]);
    this.observe();
  }
  initializeFilteredGroups() {
    var _a, _b;
    this.filteredGroups = (_b = (_a = this._data) === null || _a === void 0 ? void 0 : _a.groups) === null || _b === void 0 ? void 0 : _b.filter((group) => { var _a; return (_a = group.subGroups) === null || _a === void 0 ? void 0 : _a.length; });
  }
  componentWillLoad() {
    this._data = getPlainPropValue(this.data);
    this._showMoreLabel = getPlainPropValue(this.showMoreLabel);
    this._showLessLabel = getPlainPropValue(this.showLessLabel);
    store.dispatch(setLinearProductData({ environmentalData: {
        data: this._data,
        showMoreLabel: this._showMoreLabel,
        showLessLabel: this._showLessLabel,
      } }));
    this.unsubscribe = store.subscribe(() => {
      const { data, activeProductTab, lastActionType } = store.getState().product;
      if (lastActionType !== ACTION_TYPES.SET_ACTIVE_PRODUCT_TAB)
        return;
      if (!data[activeProductTab].environmentalData)
        return;
      const { data: environmentalData, showMoreLabel, showLessLabel, } = data[activeProductTab].environmentalData;
      this._data = environmentalData;
      this._showMoreLabel = showMoreLabel;
      this._showLessLabel = showLessLabel;
      if (!this._data) {
        return;
      }
      this.initializeStickyBarTab();
      this.initializeLinks();
      this.initializeFilteredGroups();
    });
  }
  componentDidLoad() {
    if (!this._data) {
      return;
    }
    this.initializeStickyBarTab();
    this.initializeLinks();
    this.initializeFilteredGroups();
  }
  disconnectedCallback() {
    var _a;
    (_a = this.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  watchMultiple(newValue, oldValue) {
    if (newValue.data !== oldValue.data) {
      this._data = getPlainPropValue(newValue.data);
      if (!this._data)
        return;
      this.initializeLinks();
      this.initializeStickyBarTab();
      this.initializeFilteredGroups();
    }
    if (newValue.showMoreLabel !== oldValue.showMoreLabel) {
      this._showMoreLabel = getPlainPropValue(newValue.showMoreLabel);
    }
    if (newValue.showLessLabel !== oldValue.showLessLabel) {
      this._showLessLabel = getPlainPropValue(newValue.showLessLabel);
    }
  }
  observe() {
    observeIntersectionWithHeader(this.el, (entries) => {
      var _a, _b;
      if ((_a = entries[0]) === null || _a === void 0 ? void 0 : _a.isIntersecting) {
        setTabActive({
          type: ETabType.ENVIRONMENTALDATA,
          title: (_b = this._data) === null || _b === void 0 ? void 0 : _b.name,
        });
        this.setTabActive.emit();
      }
    });
  }
  render() {
    var _a, _b, _c;
    if (!this._data)
      return null;
    return (h("pes-collapsible-container", { class: "environmental__data", toggleColor: "default" }, this.isMobileView && h("pes-logo", { slot: 'header', title: (_a = this._data) === null || _a === void 0 ? void 0 : _a.name, logo: (_b = this._data) === null || _b === void 0 ? void 0 : _b.logo }), h("div", { class: "section" }, h("div", { class: "environmental__data__section--primary" }, h("pes-environmental-detail", { title: this._data.name, description: this._data.description, logo: this._data.logo, links: this.links, isMobile: this.isMobileView }), Boolean((_c = this.filteredGroups) === null || _c === void 0 ? void 0 : _c.length) && (h("pes-environmental-characteristics", { groups: this.filteredGroups, showMoreLabel: this._showMoreLabel, showLessLabel: this._showLessLabel, isMobile: this.isMobileView }))))));
  }
  static get is() { return "pes-environmental-data"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["environmental-data.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["environmental-data.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string | TEnvironmentalDataInfo",
          "resolved": "string | { name?: string; altName?: string; description?: string; links?: TEnvironmentalDataLink[]; logo?: TEnvironmentalLogo; groups: TEnvironmentalGroup[]; }",
          "references": {
            "TEnvironmentalDataInfo": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Environmental data"
        },
        "attribute": "plain-data",
        "reflect": false
      },
      "showMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Label for show more link"
        },
        "attribute": "plain-show-more-label",
        "reflect": false
      },
      "showLessLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Label for show less link"
        },
        "attribute": "plain-show-less-label",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "_data": {},
      "_showMoreLabel": {},
      "_showLessLabel": {},
      "links": {},
      "filteredGroups": {},
      "isMobileView": {}
    };
  }
  static get events() {
    return [{
        "method": "setTabActive",
        "name": "setTabActive",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
  static get elementRef() { return "el"; }
  static get watchers() {
    return [{
        "propName": "data",
        "methodName": "watchMultiple"
      }, {
        "propName": "showMoreLabel",
        "methodName": "watchMultiple"
      }, {
        "propName": "showLessLabel",
        "methodName": "watchMultiple"
      }];
  }
  static get listeners() {
    return [{
        "name": "resize",
        "method": "windowSizeDidChange",
        "target": "window",
        "capture": false,
        "passive": true
      }, {
        "name": "tabClicked",
        "method": "handleTabClicked",
        "target": "window",
        "capture": false,
        "passive": false
      }, {
        "name": "scrollToEnvironmentalData",
        "method": "handleScrollToEnvironmentalData",
        "target": "window",
        "capture": false,
        "passive": false
      }];
  }
}
